import type { ReactNode } from "react";

interface SectionWithHeaderProps {
  title: string;
  description?: string;
  className?: string;
  actions?: ReactNode;
  children?: ReactNode;
}

const sectionClasses =
  "flex flex-col gap-6 text-slate-900 dark:text-slate-100 mt-0 first:mt-0 last:mb-0";
const headerClasses =
  "grid w-full grid-cols-[auto_minmax(0,1fr)] items-start gap-3 sm:gap-4";
const indicatorClasses =
  "w-1 self-stretch rounded-full bg-gradient-to-b from-sky-500 to-indigo-500";
const contentClasses =
  "flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-4";
const bodyClasses = "w-full min-w-0";
const titleClasses = "m-0 text-xl font-semibold text-slate-800 dark:text-slate-100";
const descriptionClasses = "mt-1 text-sm leading-relaxed text-slate-500 dark:text-slate-400";
const actionsClasses =
  "flex flex-wrap justify-start gap-3 sm:justify-end";
const contentWrapperClasses = "flex flex-col gap-4";

export function SectionWithHeader({
  title,
  description,
  className,
  actions,
  children,
}: SectionWithHeaderProps) {
  const sectionClassNames = [sectionClasses, className].filter(Boolean).join(" ");

  return (
    <section className={sectionClassNames}>
      <div className={headerClasses}>
        <div className={indicatorClasses} aria-hidden="true" />
        <div className={contentClasses}>
          <div className={bodyClasses}>
            <h3 className={titleClasses}>{title}</h3>
            {description ? (
              <p className={descriptionClasses}>{description}</p>
            ) : null}
          </div>
          {actions ? <div className={actionsClasses}>{actions}</div> : null}
        </div>
      </div>
      {children ? <div className={contentWrapperClasses}>{children}</div> : null}
    </section>
  );
}
